import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,reorderArray } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { Storage } from "@ionic/storage";
import { SERVER_URL } from "../../config";
import { MenuPage } from '../menu/menu';
import { AddcategoriamenuPage } from '../addcategoriamenu/addcategoriamenu';

/**
 * Generated class for the CategoriemenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-categoriemenu',
  templateUrl: 'categoriemenu.html',
})
export class CategoriemenuPage {
  categorieMenu;
  errorMessage;
  user;
  link = SERVER_URL + "/manifesti/files/"

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,
    private readonly storage: Storage,
    public nav: NavController

  ) {

  }
  getCategorieMenu() {
    this.rest.getCategorieMenu()
      .subscribe(
        categorieMenu => {this.categorieMenu = categorieMenu;
      //  alert(JSON.stringify(this.categorieMenu))
        },
        error => this.errorMessage = <any>error);
  }
  openMenuPage(categoriaMenu) {
    console.log("openMenuPage:" + JSON.stringify(categoriaMenu));

    this.nav.push(MenuPage, { categoriaMenu: categoriaMenu });


  }
  openAddcategoriaMenuPage() {

    this.nav.push(AddcategoriamenuPage);

  }
  reorderItems(indexes) {
    console.log("reorderItems:" + JSON.stringify(indexes));

    this.categorieMenu = reorderArray(this.categorieMenu, indexes);


    console.log("reorderItems list:" + JSON.stringify(this.categorieMenu));
    var i = 0;
    this.categorieMenu.forEach(function (element) {

      console.log(element["name"]);
      element["visibilita"] = i;
      i++;
    });
    console.log("reorderItems list durante:" + JSON.stringify(this.categorieMenu));



    this.rest.aggiornaListCategoriaMenu(this.categorieMenu);

  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad CategoriemenuPage');
    this.getCategorieMenu();
    this.storage.get('user').
    then((value) => {
      this.user = value;
      console.log(" constructor indirizzo STOREEEEEEEEEEEEEEEEEEEE:" + JSON.stringify(this.user))

    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/categoriemenu/categoriemenu.ts